// Libs
import React, { useState, useContext, useEffect } from "react";
import { useObserver, useRouter, getHistory } from "@shoothill/core";
import { Link as RouterLink } from "react-router-dom";
import { CustomInput } from "Globals/Styles/AppStyling";
import { Box, Typography, Link, makeStyles, useMediaQuery } from "@material-ui/core";
import { StoresContext, Stores } from "Globals/Stores";
import { StyledButton } from "Globals/Styles/ButtonStyles";
import styled from "styled-components";
import RegisterApplicantViewModel from "Globals/ViewModels/Applicant/RegisterApplicantViewModel";

const BackgroundImageContainer = styled(Box)`
    display: flex;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    min-height: 100vh;
    height: auto;
    background-image: url("login_bg.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
`;
const Row = styled(Box)`
    display: flex;
    margin: 30px 0;
    @media (max-width: 768px) {
        justify-content: center;
        margin: 15px 0;
    }
`;

const useStyles = makeStyles({
    wrapper: {
        padding: "90px 120px 0 80px",
        backgroundColor: "#ffffffef",

        "@media (max-width:768px)": {
            padding: "15px 10px 10px",
            width: "100%",
            margin: "0 auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "start",
        },
    },
    p1: {
        fontSize: "14px",
        "@media (max-width:768px)": {
            textAlign: "center",
        },
    },
    form: {
        "@media (max-width: 768px)": {
            width: "100%",
        },
    },
    input: {
        "& .MuiInputBase-input": {
            "@media (max-width: 768px)": {
                height: "48px",
                boxSizing: "border-box",
                width: "300px",
            },
        },
        "& .MuiFormControl-root": {
            "@media (max-width: 768px)": {
                boxSizing: "border-box",
                width: "300px",
                margin: "15px 0",
            },
        },
    },
});

export const RegisterApplicantView: React.FC = () => {
    const storesContext = useContext<Stores>(StoresContext);
    const [viewModel] = useState(() => new RegisterApplicantViewModel());
    const classes = useStyles();
    const isMobile: boolean = useMediaQuery("screen and (max-width: 767px)") ? true : false;
    return useObserver(() => (
        <>
            <BackgroundImageContainer>
                <Box className={classes.wrapper}>
                    <Row>
                        <img
                            src="/hightownLogo.svg"
                            alt="Hightown"
                            style={isMobile ? { width: "250px" } : { cursor: "pointer", width: "363px" }}
                            onClick={() => getHistory().push("/")}
                        />
                    </Row>
                    <Row>
                        <Typography style={{ fontSize: "28px", fontWeight: "bold" }}>Good {new Date().getHours() < 12 ? "Morning" : "Afternoon"},</Typography>
                    </Row>
                    <Row>
                        <Typography className={classes.p1}>
                            Welcome to the Hightown Housing Group customer application portal. Before we take you to the application form we need a few details from you to create
                            your account.
                        </Typography>
                    </Row>
                    <Typography style={{ color: "#007AFF", cursor: "pointer" }}>Why do you need an account?</Typography>
                    <form className={classes.form}>
                        <Row style={{ marginBottom: "10px" }}>
                            <Typography className={classes.p1} style={{ fontSize: "16px", fontWeight: "bold" }}>
                                Set your password
                            </Typography>
                        </Row>
                        <Row style={{ marginTop: "10px" }}>
                            <Typography className={classes.p1} style={{ fontSize: "15px" }}>
                                Please ensure your password contains at least one capital letter and one symbol and is more than 7 characters long.
                            </Typography>
                        </Row>
                        <Row>
                            <CustomInput className={classes.input} type="password" label="Password" validateOnBlur={true} viewModel={viewModel} fieldName="password" />
                        </Row>
                        <Row>
                            <CustomInput
                                className={classes.input}
                                type="password"
                                label="Confirm password"
                                validateOnBlur={true}
                                viewModel={viewModel}
                                fieldName="confirmPassword"
                            />
                        </Row>
                        <Row>
                            <StyledButton style={{ margin: 0 }} onClick={viewModel.registerApplicant}>
                                {viewModel.IsLoading ? <span>Please wait...</span> : <span>Confirm password and continue</span>}
                            </StyledButton>
                        </Row>
                        {viewModel.errorMessage != "" && (
                            <Row>
                                <Typography variant="caption" style={{ color: "red" }}>
                                    {viewModel.errorMessage}
                                </Typography>
                            </Row>
                        )}
                    </form>
                </Box>
            </BackgroundImageContainer>
        </>
    ));
};

// <BackgroundImageContainer>
//     <Box className={classes.wrapper}>
//         <Row>
//             <img src="/hightownLogo.svg" alt="Hightown" style={{ cursor: "pointer", width: "363px" }} onClick={() => getHistory().push("/")} />
//         </Row>
//         <Row>
//             <Typography style={{ fontSize: "28px", fontWeight: "bold" }}>Good morning,</Typography>
//         </Row>
//         <Row>
//             <Box>
//                 <Typography className={classes.p1}>
//                     Welcome to the Hightown Housing Group customer application portal. Before we take you to the application form we need a few details from you to
//                     create your account.
//                 </Typography>
//                 <Typography style={{ color: "#007AFF", cursor: "pointer" }}>Why do you need an account?</Typography>
//             </Box>
//         </Row>
//         <form onSubmit={viewModel.registerApplicant} className={classes.form}>
// <Row style={{ marginBottom: "10px" }}>
//     <Typography style={{ fontSize: "16px", fontWeight: "bold" }}>Set your password</Typography>
// </Row>
// <Row style={{ marginTop: "10px" }}>
//     <Typography style={{ fontSize: "15px" }}>
//         Please ensure your password contains at least one capital letter and one symbol and is more than 7 characters long.
//     </Typography>
// </Row>
// <Row>
//     <CustomInput className={classes.input} type="password" label="Password" validateOnBlur={true} viewModel={viewModel} fieldName="password" />
// </Row>
//             <Row>
//                 <Typography style={{ marginTop: "12px", marginLeft: "60px", fontSize: "10px", whiteSpace: "nowrap" }}>
//                     Must contain at least 7 letters, one capital letter, one number and a symbol.
//                 </Typography>
//             </Row>
//             <Row style={{ marginTop: "40px" }}>
// <CustomInput
//     className={classes.input}
//     type="password"
//     label="Confirm password"
//     validateOnBlur={true}
//     viewModel={viewModel}
//     fieldName="confirmPassword"
// />
//             </Row>
// <Row>
//     <StyledButton type="submit">{viewModel.IsLoading ? <span>Please wait...</span> : <span>Confirm password and continue</span>}</StyledButton>
// </Row>
// {viewModel.errorMessage != "" && (
//     <Row>
//         <Typography variant="caption" style={{ color: "red" }}>
//             {viewModel.errorMessage}
//         </Typography>
//     </Row>
// )}
//         </form>
//     </Box>
// </BackgroundImageContainer>
